export default {
  namespaced: true,
  actions: {
    async getBanners({}) {
      try {
        const response = await fetch(`https://assets.staage.com/${process.env.VUE_APP_STAGE}/platform-b-objects.json`)
        return response.json()
      } catch (err) {
        console.error(err)
      }
    },
    async getSuitability({}) {
      try {
        const response = await fetch(`https://static.staage.com/${process.env.VUE_APP_STAGE}/platform-suitability-objects.json`)
        return response.json()
      } catch (err) {
        console.error(err)
      }
    },
    async getPlans({}) {
      try {
        const response = await fetch(`https://static.staage.com/${process.env.VUE_APP_STAGE}/platform-web-plans-objects.json`)
        return response.json()
      } catch (err) {
        console.error(err)
      }
    }
  }
}
